<template>
    <div class="gallery" :class="[excludeFromPrintClassName]">
        <div v-for="(image, index) in value" :key="index" class="galery_item">
            <picture v-full-image-path="image || {}" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            required: true
        },

        excludeFromPrintClassName: {
            type: String,
            required: true
        }
    }
};
</script>
